export const marketing = [
	'24 24',
	`
<path d="M16.7578 0.622368L6.85259 5.30987H0.624695V13.5805L2.66344 19.3722H7.14212L5.32337 14.3722H6.72364L16.8431 19.375H19.3718L19.375 0.622368H16.7578ZM6.24966 13.1224H4.06118L4.06356 14.5657L5.35727 18.1224H3.54868L1.87469 13.3669V6.55967H6.2497L6.24966 13.1224ZM7.50454 6.38428L14.3747 3.13299V16.7603L7.50458 13.3638L7.50454 6.38428ZM18.122 18.125H17.1352L15.6247 17.3782V2.54151L17.0388 1.87237H18.1247L18.122 18.125Z"/>
`,
];
